/**
 * Error403/index.js
 * desc: component represents 403 error page
 * note: stateless presentational component
 */
'use strict';

import { Component } from 'react';
import { BridgeIllustration, GondolaPaddleIllustration, ManOnGondolaIllustration } from '../../components/Illustration';
import { translate } from '../../utilities/localization';
import './styles.css';


export class Error403 extends Component {

    render() {
        const { className } = this.props;

        return (
            <section id="error403" className={ className }>
                <aside>{ translate('error403.status.text') }</aside>
                <main className="illustrations">
                    <div className="illustration-combined">
                        <BridgeIllustration/>
                        <div className="gondola-combined">
                            <GondolaPaddleIllustration/>
                            <ManOnGondolaIllustration/>
                        </div>
                    </div>
                </main>
                <hgroup>
                    <h1>{ translate('error403.header.text') }</h1>
                    <h2>{ translate('error403.subHeader.text') }</h2>
                    <h2>{ translate('error403.subHeader.text2') }</h2>
                </hgroup>
            </section>
        );
    }
};


export default Error403;
